module.exports = __webpack_public_path__ + "img/logo-vermelho.899ce803.svg";